// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2Hno9","cell":"ColumnAccessor_cell__3Za0j","firstCellAccent":"ColumnAccessor_firstCellAccent__1Ow2p"};